import RefreshIcon from '@mui/icons-material/Refresh';
import { CircularProgress, Button } from "@mui/material";
import axios from 'axios';
import { t } from "i18next";
import React, { useEffect, useRef, useState } from 'react';
import { toast } from "react-toastify";

import DatahubService from "../services/Datahub/DatahubService";
import onlineProvidersTestPayload from "../utils/constants/onlineProvidersTestPayload";
import providerList from "../utils/constants/providerList";


const MonitoringProviders = () => {
    const [providersData, setProvidersData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const cancelToken = useRef(null);
    const timer = useRef(null);
    const intervalRef = useRef(null);

    const checkProvidersStatus = (resetInterval = false) => {
        setIsLoading(true);
        clearTimeout(timer.current);

        timer.current = setTimeout(() => {
            if (cancelToken.current) {
                cancelToken.current.cancel();
            }
            cancelToken.current = axios.CancelToken.source();

            DatahubService.getPricing(onlineProvidersTestPayload, cancelToken.current)
                .then((response) => {
                    const onlineProviders = response.data.Solutions.map(solution => solution.Transporteur);
                    const providersStatus = providerList.map(provider => ({
                        name: provider,
                        online: onlineProviders.includes(provider)
                    }));
                    setProvidersData(providersStatus);
                })
                .catch(() => {
                    toast.error(
                        t('vehicleInfoForm:dataRetrievalFailed'),
                        {
                            position: "top-center",
                            autoClose: 3500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        }
                    );
                })
                .finally(() => {
                    setIsLoading(false);
                    if (resetInterval) {
                        resetCheckInterval();
                    }
                });
        }, 300);
    };

    const resetCheckInterval = () => {
        clearInterval(intervalRef.current);
        intervalRef.current = setInterval(() => {
            checkProvidersStatus();
        }, 60000);
    };

    useEffect(() => {
        checkProvidersStatus();
        intervalRef.current = setInterval(checkProvidersStatus, 60000);

        return () => {
            clearInterval(intervalRef.current);
            if (cancelToken.current) {
                cancelToken.current.cancel();
            }
        };
    }, []);

    const handleRefresh = () => {
        checkProvidersStatus(true);
    };

    const renderStatusMessage = () => {
        const offlineProviders = providersData.filter(provider => !provider.online).map(provider => provider.name);
        if (providersData.length === 0) {
            return 'Chargement...';
        } else if (offlineProviders.length === 0) {
            return 'Tous les services de livraison sont en ligne.';
        } else if (offlineProviders.length === 1) {
            return `Le service de livraison suivant est hors ligne : ${offlineProviders[0]}.`;
        } else {
            return `Les services de livraison suivants sont hors ligne : ${offlineProviders.join(', ')}.`;
        }
    };

    const ProviderStatus = ({ name, online }) => (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px' }}>
            <span>{name}</span>
            <div
                style={{
                    width: '15px',
                    height: '15px',
                    borderRadius: '50%',
                    backgroundColor: online ? 'green' : 'red',
                    margin: '5px 0',
                }}
            />
            <span>{online ? 'En ligne' : 'Hors ligne'}</span>
        </div>
    );

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "600px",
                    height: "40px",
                }}
            >
                {renderStatusMessage()}
                {isLoading ?
                    <CircularProgress size={24}/> :
                    <Button
                        onClick={handleRefresh}
                    >
                        <RefreshIcon />
                    </Button>
                }
            </div>

            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "600px",
                }}
            >
                {providersData.length === 0 ?
                    <CircularProgress size={24}/> :
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        {providersData.map(provider => (
                            <ProviderStatus key={provider.name} name={provider.name} online={provider.online} />
                        ))}
                        <div
                            style={{
                                width: "24px",
                                display: "flex",
                                justifyContent: "end",
                            }}
                        >
                            {isLoading ?
                                <CircularProgress size={24}/> :
                                <Button
                                    onClick={handleRefresh}
                                >
                                    <RefreshIcon />
                                </Button>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default MonitoringProviders;
